'use client';

import { useEffect } from 'react';
import { setPageTemplate } from '@/libraries/monitoring/web-vitals';

export interface PageTemplateTrackerProps {
  /** The CMS page type, e.g. `HotelPageDto` */
  pageTemplate?: string;
}

/**
 * A render-less client component that records the current page template,
 * so the web vitals reported to Application Insights can be segmented by it.
 */
const PageTemplateTracker = ({ pageTemplate }: PageTemplateTrackerProps) => {
  useEffect(() => {
    setPageTemplate(pageTemplate);
  }, [pageTemplate]);

  return null;
};

PageTemplateTracker.displayName = 'PageTemplateTracker';

export default PageTemplateTracker;
